import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-contexts-contexts',
  templateUrl: './contexts-contexts.component.html',
  styleUrls: ['./contexts-contexts.component.scss']
})
export class ContextsContextsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
